import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";
import { IFetchUserBookingParams } from "../domain";

export const useGetUserBookingDetails = <TData = any, TError = any>(
  params: IFetchUserBookingParams,
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { bookingApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      bookingApiService.createCancellableRequest((cancelToken) =>
        bookingApiService.getUserBookingDetail(params, cancelToken)
      ),
    [bookingApiService, params]
  );

  return useQuery(QueryKeys.bookingDetailOfUser(params), queryFn, queryOptions);
};
